const PictureDiv = ({ path, name = '', alt = '' }) => {
	return (
		<div className="w-[90px] h-[80px] lg:w-[120px] lg:h-[100px]">
			<img
				src={path}
				alt={alt}
				title={name}
				loading="lazy"
				decoding="async"
				fetchpriority="high"
				className={`w-full h-full rounded-2xl object-cover object-center`}
			/>
		</div>
	);
};

export default PictureDiv;
